import axios from 'axios';
import { getAuthToken } from './auth';
import { getAxiosBaseURL } from '../config/apiConfig';

// Unified base URL (without /api/v1) using central config
const API_BASE_URL = getAxiosBaseURL();

// Helper function to get authorization header
const getAuthHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// --- Instance Axios Mặc Định ---
// Dùng cho các request JSON thông thường
export const api = axios.create({
  baseURL: API_BASE_URL,
});

// Interceptor để tự động thêm token vào các request
api.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});


// --- Instance Axios Dành Cho Upload File ---
// Instance này KHÔNG có interceptor thay đổi header Content-Type
export const uploadApi = axios.create({
  baseURL: API_BASE_URL,
  // Axios sẽ tự động set Content-Type là multipart/form-data khi data là FormData
});

// Interceptor cho uploadApi chỉ để thêm token, không làm gì khác
uploadApi.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default api;
